import { Component, OnInit} from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-custom-selections-web',
  templateUrl: './custom-selections-web.component.html',
  styleUrls: ['./custom-selections-web.component.scss'],
  providers: [SharedService]
})
export class CustomSelectionWebComponent implements OnInit {

  selection: any = { year: null };
  years: any = [];
  error: any = {};
  currentYear: any = ""

  
  constructor(
    private authService : AuthService,
    private keycloakService: KeycloakService,
    private appConstants: AppConstants
  ) { }

  userInfo: any;
  async ngOnInit() {
    this.isLoading = true
    this.createSelectionComponenetLoading()
    let currentYear = new Date().getFullYear();
    this.currentYear = currentYear - 1;
    this.selection.year = null;
      const user = this.appConstants.userDetails
      this.userInfo = user;
}

  
  
  createComponentSelectionData : any = {}
  advancedSearchVisible : boolean = false
 async createSelectionComponenetLoading() {

   let createComponentSelectionData;
     const token = await this.keycloakService.getToken();
     createComponentSelectionData = {
       headers: {
         token: token,
         customerId: "",
       },
     }

      let permissions : any = {
      cancelSelections : await this.authService.checkRoleExist('cancelSelections'),
      markSelectionsSent : await this.authService.checkRoleExist('markSelectionsSent'),
      downloadSelectionNotices : await this.authService.checkRoleExist('downloadSelectionNotices'),
      emailSelectionNotices : await this.authService.checkRoleExist('emailSelectionNotices'),
      createSelectionLetters : await this.authService.checkRoleExist('createSelectionLetters'),
      candeleteSelections : await this.authService.checkRoleExist('deleteSelections'),
      canCancelComponents : await this.authService.checkRoleExist('cancelComponents'),
      }

      createComponentSelectionData['isOpen'] = true;
      createComponentSelectionData['userInfo'] = this.appConstants.userDetails
      createComponentSelectionData['permissions'] = permissions;
      createComponentSelectionData['endpoints'] = this.appConstants.endPoints;
      this.createComponentSelectionData = { ...{}, ...createComponentSelectionData };
      this.getToken();
      setInterval(() => {
       this.getToken();
     }, 1000);
    }
 

 sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }

}
